var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Button } from '@zapier/design-system';
import UniversalNavLink from '../UniversalNavLink';
import { usageLink } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import UniversalSidebarError from './UniversalSidebarError';
import UniversalSidebarSubheaderButton from './UniversalSidebarSubheaderButton';
import UniversalSidebarUsage from './UniversalSidebarUsage/UniversalSidebarUsage';
import useSidebarData from './utils/useSidebarData';
import UniversalSidebar, { isLinkSelected } from './UniversalSidebar';
const infinitize = (number) => {
    return number === -1 ? Infinity : number;
};
const MaybeCta = (props) => {
    const isFree = props.planAmount === 0;
    const isNearTaskLimit = props.numTasks / props.numTasksMax >= 0.8;
    const isNearZapLimit = props.numZaps / props.numZapsMax >= 0.8;
    return isFree || isNearTaskLimit || isNearZapLimit ? (isolateComponent(Button, { color: "secondary", href: "/app/billing/plans", isFullWidth: true, size: "small" }, "Upgrade plan")) : null;
};
const Styles = labelStyles('UniversalSidebarContainer', {
    footerWrapper: {
        overflow: 'hidden',
        padding: 10,
    },
});
const FooterWrapper = ({ children }) => (isolateComponent("div", { css: Styles.footerWrapper }, children));
const UniversalSidebarContainer = (_a) => {
    var { currentAccountId } = _a, props = __rest(_a, ["currentAccountId"]);
    const { useQuery } = useUniversalNavContext();
    const result = useSidebarData({ accountId: currentAccountId, useQuery });
    const { loading, data, error } = result;
    const renderedUsageLink = (isolateComponent(UniversalNavLink, { href: usageLink.href, icon: usageLink.icon, isCollapsed: props.isCollapsed, isSelected: isLinkSelected(usageLink.href || '', props.selectedHref), isSidebar: true, text: usageLink.text }));
    const renderFooter = () => {
        if (props.isCollapsed) {
            return renderedUsageLink;
        }
        if (error) {
            return (isolateComponent(React.Fragment, null,
                renderedUsageLink,
                isolateComponent(FooterWrapper, null,
                    isolateComponent(UniversalSidebarError, null, error.message))));
        }
        if (loading || !(data === null || data === void 0 ? void 0 : data.account)) {
            return null;
        }
        const { plan, usage } = data.account;
        const tiers = plan.tiers;
        const freeTier = tiers && tiers.find((tier) => tier.pricePerTask === 0);
        const numFreeTasksMax = freeTier ? freeTier.numTasks : 0;
        const normalizedUsage = {
            isPlanMetered: plan.hasMeteredBilling,
            numTasks: usage.tasks.total,
            numFreeTasksMax,
            numTasksMax: infinitize(usage.tasks.limit),
            numZaps: usage.zaps.on,
            numZapsMax: infinitize(usage.zaps.limit),
        };
        return (isolateComponent(FooterWrapper, null,
            isolateComponent(UniversalSidebarUsage, Object.assign({}, normalizedUsage, { resetDate: usage.periodEnd, title: `${plan.name} Plan` }),
                isolateComponent(MaybeCta, Object.assign({}, normalizedUsage, { planAmount: plan.amount })))));
    };
    return (isolateComponent(UniversalSidebar, Object.assign({}, props, { logoAriaLabel: "Go to dashboard", logoHref: "/app/dashboard", renderFooter: renderFooter, renderSubheader: () => (isolateComponent(UniversalSidebarSubheaderButton, { href: "/webintent/create-zap?entry-point-method=make_a_zap_call_to_action", iconName: "formAdd", isCollapsed: props.isCollapsed, text: "Create Zap" })) })));
};
export default UniversalSidebarContainer;
//# sourceMappingURL=UniversalSidebarContainer.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
